(function () {
  'use strict';

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-thumb]'));
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-slide]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-dot]'));
    var stage = gallery.querySelector('.bessia-product__stage');
    var prevButton = gallery.querySelector('[data-product-prev]');
    var nextButton = gallery.querySelector('[data-product-next]');
    var mobileGallery = window.matchMedia('(max-width: 989px)');
    var scrollFrame = null;
    var activeIndex = Math.max(0, slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    }));

    function updateArrows() {
      if (prevButton) prevButton.classList.toggle('is-hidden', activeIndex === 0);
      if (nextButton) nextButton.classList.toggle('is-hidden', slides.length < 2);
    }

    function setActiveIndex(index) {
      activeIndex = (index + slides.length) % slides.length;
      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('is-active', thumbIndex === activeIndex);
        thumb.setAttribute('aria-current', thumbIndex === activeIndex ? 'true' : 'false');
      });
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
      });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
        dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
      });
      updateArrows();
    }

    function show(index) {
      setActiveIndex(index);
      if (stage && mobileGallery.matches && slides[activeIndex]) {
        stage.scrollTo({
          left: slides[activeIndex].offsetLeft,
          behavior: 'smooth'
        });
      }
    }

    function syncActiveFromScroll() {
      if (!stage || !mobileGallery.matches || slides.length < 2) return;
      var closestIndex = activeIndex;
      var closestDistance = Infinity;
      slides.forEach(function (slide, slideIndex) {
        var distance = Math.abs(slide.offsetLeft - stage.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = slideIndex;
        }
      });
      if (closestIndex !== activeIndex) setActiveIndex(closestIndex);
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        show(index);
      });
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        show(index);
      });
    });

    if (stage) {
      stage.addEventListener('scroll', function () {
        if (!mobileGallery.matches) return;
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(syncActiveFromScroll);
      }, { passive: true });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        show(activeIndex + 1);
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        show(activeIndex - 1);
      });
    }

    var touchStartX = 0;
    var touchStartY = 0;
    gallery.addEventListener('touchstart', function (event) {
      var touch = event.touches && event.touches[0];
      if (!touch) return;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });

    gallery.addEventListener('touchend', function (event) {
      var touch = event.changedTouches && event.changedTouches[0];
      if (!touch || slides.length < 2) return;
      if (mobileGallery.matches) return;
      var deltaX = touch.clientX - touchStartX;
      var deltaY = touch.clientY - touchStartY;
      if (Math.abs(deltaX) < 44 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;
      show(activeIndex + (deltaX > 0 ? 1 : -1));
    }, { passive: true });

    setActiveIndex(activeIndex);
  });

  document.querySelectorAll('.bessia-product__tabs a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var id = link.getAttribute('href');
      var section = id && document.querySelector(id);
      if (!section) return;

      var marker = section.querySelector('.bessia-product__eyebrow') || section.querySelector('h2, h3') || section;
      var header = document.querySelector('[data-header]');
      var headerHeight = header ? header.getBoundingClientRect().height : 0;
      var extraOffset = window.matchMedia('(max-width: 989px)').matches ? 18 : 28;
      var targetTop = marker.getBoundingClientRect().top + window.pageYOffset - headerHeight - extraOffset;

      event.preventDefault();
      window.history.pushState(null, '', id);
      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: 'smooth'
      });
    });
  });

  function markBrokenProductImage(image) {
    if (!image) return;
    image.hidden = true;
    image.setAttribute('aria-hidden', 'true');
    var ingredient = image.closest('.bessia-ingredient');
    if (ingredient) ingredient.classList.add('has-missing-image');
    var beforeAfter = image.closest('.bessia-before-after');
    if (beforeAfter) beforeAfter.classList.add('has-missing-image');
  }

  document.querySelectorAll('.bessia-ingredient img, .bessia-before-after img').forEach(function (image) {
    image.addEventListener('error', function () {
      markBrokenProductImage(image);
    });
    if (image.complete && image.naturalWidth === 0) {
      markBrokenProductImage(image);
    }
  });

  document.querySelectorAll('[data-quantity-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('[data-quantity-input]');
    var minus = stepper.querySelector('[data-quantity-minus]');
    var plus = stepper.querySelector('[data-quantity-plus]');
    if (!input) return;

    function setValue(next) {
      var value = Math.max(1, parseInt(next, 10) || 1);
      input.value = value;
      var form = stepper.closest('form');
      var hidden = form && form.querySelector('[data-hidden-quantity]');
      if (hidden) hidden.value = value;
    }

    if (minus) {
      minus.addEventListener('click', function () {
        setValue((parseInt(input.value, 10) || 1) - 1);
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        setValue((parseInt(input.value, 10) || 1) + 1);
      });
    }

    input.addEventListener('change', function () {
      setValue(input.value);
    });
  });

  function formatProductMoney(cents) {
    var amount = Math.round((Number(cents) || 0) / 100);
    try {
      return '$' + new Intl.NumberFormat('es-CO', {
        maximumFractionDigits: 0
      }).format(amount);
    } catch (error) {
      return '$' + amount.toLocaleString('es-CO');
    }
  }

  function buildWhatsappUrl(number, title, variant, available) {
    var flavor = variant && variant.options && variant.options.length ? ' - ' + variant.options.join(' / ') : '';
    var message = available
      ? 'Hola, quiero asesoria por WhatsApp sobre el producto ' + title + flavor
      : 'Hola, quiero realizar un encargo por WhatsApp del producto agotado ' + title + flavor;
    return 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
  }

  document.querySelectorAll('[data-buy-now]').forEach(function (button) {
    button.addEventListener('click', function () {
      var form = button.closest('form');
      if (!form || button.disabled) return;

      var variantInput = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[data-hidden-quantity], [name="quantity"]');
      var variantId = variantInput && variantInput.value;
      var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
      if (!variantId) return;

      if (button.hasAttribute('data-direct-checkout')) {
        window.location.href = '/cart/' + encodeURIComponent(variantId) + ':' + quantity + '?checkout';
        return;
      }

      button.disabled = true;
      var originalText = button.textContent;
      button.textContent = 'Procesando...';

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', String(quantity));

      fetch((window.BessiaTheme && window.BessiaTheme.routes && window.BessiaTheme.routes.cartAdd ? window.BessiaTheme.routes.cartAdd : '/cart/add') + '.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Buy now failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          window.location.href = '/cart/' + encodeURIComponent(variantId) + ':' + quantity + '?checkout';
        })
        .finally(function () {
          button.textContent = originalText;
          button.disabled = false;
        });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantPicker = form.querySelector('[data-variant-picker]');
    var variantsData = form.querySelector('[data-product-variants-json]');
    if (!variantPicker || !variantsData) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsData.textContent || '[]');
    } catch (error) {
      variants = [];
    }
    if (!variants.length) return;

    var section = form.closest('.bessia-product');
    var variantInputs = section ? section.querySelectorAll('[data-product-variant-input]') : form.querySelectorAll('[data-product-variant-input]');
    var addButtons = section ? section.querySelectorAll('.bessia-product__add') : form.querySelectorAll('.bessia-product__add');
    var buyNowButtons = section ? section.querySelectorAll('[data-buy-now]') : form.querySelectorAll('[data-buy-now]');
    var currentPrice = section && section.querySelector('[data-product-price-current]');
    var comparePrice = section && section.querySelector('[data-product-price-compare]');
    var discountBadge = section && section.querySelector('[data-product-discount]');
    var stickyPrice = section && section.querySelector('[data-sticky-product-price]');
    var whatsapp = section && section.querySelector('[data-product-whatsapp]');
    var whatsappLabel = section && section.querySelector('[data-product-whatsapp-label]');

    function selectedOptions() {
      return Array.prototype.slice.call(variantPicker.querySelectorAll('[data-option-position]')).map(function (group) {
        var selected = group.querySelector('.bessia-variant-swatch.is-selected');
        return selected ? selected.getAttribute('data-option-value') : '';
      });
    }

    function findSelectedVariant() {
      var options = selectedOptions();
      return variants.find(function (variant) {
        return options.every(function (value, index) {
          return variant.options && variant.options[index] === value;
        });
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      var available = Boolean(variant.available);

      variantInputs.forEach(function (input) {
        input.value = variant.id;
      });

      addButtons.forEach(function (button) {
        button.disabled = !available;
        if (button.hasAttribute('data-add-icon')) {
          button.setAttribute('aria-label', available ? (button.getAttribute('data-add-label') || 'Agregar al carrito') : 'Producto agotado');
        } else {
          button.textContent = available ? (button.getAttribute('data-add-label') || 'Agregar al carrito') : 'AGOTADO';
        }
      });

      buyNowButtons.forEach(function (button) {
        button.disabled = !available;
        button.textContent = available ? 'Comprar ahora' : 'Agotado';
      });

      if (currentPrice) currentPrice.textContent = formatProductMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatProductMoney(variant.price);
      if (comparePrice) {
        if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          comparePrice.hidden = false;
          comparePrice.textContent = formatProductMoney(variant.compare_at_price);
          if (discountBadge) {
            var savingsPercent = Math.round((Number(variant.compare_at_price) - Number(variant.price)) * 100 / Number(variant.compare_at_price));
            discountBadge.hidden = false;
            discountBadge.textContent = savingsPercent + '% OFF';
          }
        } else {
          comparePrice.hidden = true;
          comparePrice.textContent = '';
          if (discountBadge) {
            discountBadge.hidden = true;
            discountBadge.textContent = '';
          }
        }
      }

      if (whatsapp && whatsappLabel) {
        whatsappLabel.textContent = available
          ? '¿Necesitas asesoria? Chatea con nosotros.'
          : '¿Quieres pedirlo por encargo? Chatea con nosotros.';
        whatsapp.href = buildWhatsappUrl(
          whatsapp.getAttribute('data-whatsapp-number') || '',
          whatsapp.getAttribute('data-product-title') || '',
          variant,
          available
        );
      }
    }

    variantPicker.querySelectorAll('.bessia-variant-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var group = swatch.closest('[data-option-position]');
        if (!group) return;

        group.querySelectorAll('.bessia-variant-swatch').forEach(function (item) {
          var selected = item === swatch;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        updateForVariant(findSelectedVariant());
      });
    });

    updateForVariant(findSelectedVariant());
  });

  document.querySelectorAll('[data-bundle]').forEach(function (bundle) {
    bundle.addEventListener('click', function () {
      var group = bundle.closest('.bessia-bundles');
      var form = bundle.closest('form');
      if (!group || !form) return;

      group.querySelectorAll('[data-bundle]').forEach(function (item) {
        var selected = item === bundle;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      var quantity = parseInt(bundle.getAttribute('data-quantity'), 10) || 1;
      var variantId = bundle.getAttribute('data-variant-id');
      var variantInput = form.querySelector('input[name="id"]');
      if (variantInput && variantId && !form.querySelector('[data-variant-picker]')) variantInput.value = variantId;
      form.querySelectorAll('[data-quantity-input], [data-hidden-quantity]').forEach(function (input) {
        input.value = quantity;
      });

      var bundleUrl = bundle.getAttribute('data-bundle-url');
      if (bundleUrl) {
        window.location.href = bundleUrl;
      }
    });
  });

  document.querySelectorAll('[data-ingredient]').forEach(function (ingredient) {
    function setIngredientOpen(item, open) {
      item.classList.toggle('is-open', open);
      item.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    ingredient.addEventListener('click', function () {
      var grid = ingredient.closest('.bessia-ingredient-grid');
      if (grid) {
        grid.querySelectorAll('[data-ingredient].is-open').forEach(function (openIngredient) {
          if (openIngredient !== ingredient) setIngredientOpen(openIngredient, false);
        });
      }
      setIngredientOpen(ingredient, !ingredient.classList.contains('is-open'));
    });
  });

  document.querySelectorAll('[data-usage-tabs]').forEach(function (tabs) {
    var tabButtons = Array.prototype.slice.call(tabs.querySelectorAll('[data-usage-tab]'));
    var panels = Array.prototype.slice.call(tabs.querySelectorAll('[data-usage-panel]'));
    if (!tabButtons.length || !panels.length) return;

    function activateUsageTab(button) {
      var panelId = button.getAttribute('aria-controls');

      tabButtons.forEach(function (tabButton) {
        var isActive = tabButton === button;
        tabButton.classList.toggle('is-active', isActive);
        tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.id === panelId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activateUsageTab(button);
      });
    });
  });

  document.querySelectorAll('[data-ingredients-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      var section = button.closest('.bessia-product__ingredients');
      var modal = section && section.querySelector('[data-ingredients-modal]');
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('bessia-modal-open');
    });
  });

  function closeIngredientsModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bessia-modal-open');
  }

  document.querySelectorAll('[data-ingredients-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      var modal = button.closest('[data-ingredients-modal]');
      closeIngredientsModal(modal);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeIngredientsModal(document.querySelector('[data-ingredients-modal].is-open'));
  });

  document.querySelectorAll('[data-before-after]').forEach(function (wrap) {
    var line = wrap.querySelector('[data-before-after-line]');
    if (!line) return;
    var isDragging = false;

    function move(clientX) {
      var rect = wrap.getBoundingClientRect();
      var percent = Math.max(12, Math.min(88, ((clientX - rect.left) / rect.width) * 100));
      line.style.left = percent + '%';
      wrap.style.setProperty('--split', percent + '%');
    }

    wrap.addEventListener('pointerdown', function (event) {
      event.preventDefault();
      isDragging = true;
      wrap.setPointerCapture(event.pointerId);
      move(event.clientX);
    });

    wrap.addEventListener('pointermove', function (event) {
      if (!isDragging) return;
      event.preventDefault();
      move(event.clientX);
    });

    wrap.addEventListener('pointerup', function (event) {
      isDragging = false;
      if (wrap.hasPointerCapture(event.pointerId)) wrap.releasePointerCapture(event.pointerId);
    });

    wrap.addEventListener('pointercancel', function (event) {
      isDragging = false;
      if (wrap.hasPointerCapture(event.pointerId)) wrap.releasePointerCapture(event.pointerId);
    });

    wrap.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
  });

  var sticky = document.querySelector('[data-sticky-buy]');
  var mainAdd = document.querySelector('[data-main-add]');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    var mainAddVisible = true;

    function syncSticky() {
      var visible = !mainAddVisible && window.scrollY > 700;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('bessia-sticky-buy-visible', visible);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        mainAddVisible = entry.isIntersecting;
        syncSticky();
      });
    }, { threshold: 0 });

    observer.observe(mainAdd);
    window.addEventListener('scroll', syncSticky, { passive: true });
    syncSticky();
  }
})();
